<div class="container mt-4">
  <!-- <nav aria-label="breadcrumb">
    <ol class="breadcrumb">
      <li class="breadcrumb-item"><a routerLink="/home">Home</a></li>
      <li class="breadcrumb-item active" aria-current="page">Profissionais Autônomos</li>
    </ol>
  </nav> -->

  <div *ngIf="deleting" class="backdrop">
    <div class="spinner-border text-light" role="status">
      <span class="visually-hidden">Salvando as Informações...</span>
    </div>
  </div>

  <div class="page-header mb-4" *ngIf="!loading">
    <h1 class="page-title">Lista de Profissionais Autônomos</h1>
  </div>

  <!-- Botão para Criar Novo Usuário -->
  <div class="text-end mb-3" *ngIf="professionalsData.length > 0 && !loading && isAdmin">
    <button class="btn btn-primary" (click)="router.navigate(['/professionals/create'])">
      Criar Novo Profissional
    </button>
  </div>

  <!-- Exibe mensagem de carregamento enquanto os dados estão sendo buscados -->
  <div *ngIf="loading" class="spinner-container gap-2">
    <div class="spinner"></div>
    <span>Carregando profissionais...</span>
  </div>

  <div *ngIf="!loading && professionalsData.length == 0">
    <img src="../../../../../assets/img/folder.png" alt="empty" class="empty" />
    <h4>Nenhum profissional cadastrado.</h4>

    <ng-container *ngIf="!isAdmin; then askAdminToCreate; else showCreateProfessionalButton"></ng-container>
    <ng-template #askAdminToCreate>
      <p>Peça ao Administrador para cadastrar!</p>
    </ng-template>
    <ng-template #showCreateProfessionalButton>
      <button class="btn btn-primary" (click)="router.navigate(['/professionals/create'])">
        Criar Novo Profissional
      </button>
    </ng-template>
  </div>

  <app-zebra-employee-table
    *ngIf="!loading && professionalsData.length > 0"
    [headers]="professionalsHeaders"
    [data]="professionalsData"
    [itemsPerPage]="5"
    [isAdmin]="isAdmin"
    [isManager]="isManager"
    [isSupervisor]="isSupervisor"
    [isUser]="isUser"
    (edit)="onEdit($event)"
    (delete)="onDelete($event)"
    (view)="onView($event)"
  ></app-zebra-employee-table>
</div>
